// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import ConnectedLabelAndError, {
  StyledLabelAndError,
} from './StyledFormComponentWrappers';
import TextField, { TextInput } from './TextField';
import TextAreaField, {
  RawTextAreaField,
  TextAreaInput,
} from './TextAreaField';
import SelectField, { SelectInput } from './SelectField';
import PlainSelectField, { PlainSelectInput } from './PlainSelectField';
import RadioGroupField, {
  RadioGroupInput,
  RawRadioInput,
  RawRadioGroup,
} from './RadioField';
import CheckboxGroupField, { CheckboxGroupInput } from './CheckboxGroupField';
import SimpleCheckboxField from './SimpleCheckboxField';
import SingleCheckboxField from './SingleCheckboxField';
import ToggleSwitchField from './ToggleSwitchField';
import DateMaskField, { DateMaskInput } from './DateMaskField';
import PhoneMaskField, { PhoneMaskInput } from './PhoneMaskField';
import Last4SSNMaskField, { Last4SSNMaskInput } from './Last4SSNMaskField';
import MultiTreeSelectField, {
  MultiTreeSelectInput,
} from './MultiTreeSelectField';
import TreeSelectField from './TreeSelectField';
import FileField, { FileInput } from './FileField';
import CountySelectionField, {
  CountySelectionInput,
} from './CountySelectionField';
import OrganizationSelectionField, {
  OrganizationSelectionInput,
} from './OrganizationSelectionField';
import ProviderSelectionField, {
  ProviderSelectionInput,
} from './ProviderSelectionField';
import PlainCountySelectionField, {
  PlainCountySelectionInput,
} from './PlainCountySelectionField';
import ICD10Field, { ICD10Input } from './ICD10Field';
import ToothSelectorField, { ToothSelectorInput } from './ToothSelectorField';
import SignatureField, { SignatureInput } from './SignatureField';
import cx from 'classnames';

/** @typedef {{
  onSubmit: (formVals: any) => any,
  children: JSX.Element | JSX.Element[],
  className?: string
} & React.HTMLAttributes<HTMLFormElement> } HFormPropsType */

/** @type { StatelessComponent<HFormPropsType> } */
const HForm = ({ onSubmit, children, className, ...props }) => {
  const classes = cx(className, 'form-horizontal');
  return (
    <form onSubmit={onSubmit} className={classes} {...props}>
      {children}
    </form>
  );
};

HForm.displayName = 'HForm';

HForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default HForm;

// Terminology:
// 1. FormComponents suffixed with "Field" contain a label and error wrapper
// 2. FormComponents suffixed with "Input" contain an optional error wrapper, depending on whether `validate` function is given.

export {
  ConnectedLabelAndError,
  StyledLabelAndError,
  TextField,
  TextInput,
  TextAreaField,
  RawTextAreaField,
  TextAreaInput,
  SelectField,
  SelectInput,
  PlainSelectField,
  PlainSelectInput,
  RadioGroupField,
  RadioGroupInput,
  RawRadioGroup,
  RawRadioInput,
  CheckboxGroupField,
  CheckboxGroupInput,
  SimpleCheckboxField,
  SingleCheckboxField,
  ToggleSwitchField,
  DateMaskField,
  DateMaskInput,
  PhoneMaskField,
  PhoneMaskInput,
  Last4SSNMaskField,
  Last4SSNMaskInput,
  MultiTreeSelectField,
  MultiTreeSelectInput,
  TreeSelectField,
  FileField,
  FileInput,
  CountySelectionField,
  CountySelectionInput,
  OrganizationSelectionField,
  OrganizationSelectionInput,
  ProviderSelectionField,
  ProviderSelectionInput,
  PlainCountySelectionField,
  PlainCountySelectionInput,
  ICD10Field,
  ICD10Input,
  ToothSelectorField,
  ToothSelectorInput,
  SignatureField,
  SignatureInput,
};
